import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import ApiProvider from "../../../apiProvider.js";
import { isMobile } from "../../../mobileHelper.js";
import PDFViewer from "../../../Components/PDFViewer/PDFViewer.jsx";
import MobilePDFViewer from "../../../Components/PDFViewer/MobilePDFViewer.jsx";
import * as Icon from "react-bootstrap-icons";

const PayslipList = ({
    payslips,
    viewPayslip,
    onDeletePayslip,
    isPayslipAdmin,
}) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [fileName, setFileName] = useState("");
    const [fileData, setFileData] = useState();
    const [fileLink, setFileLink] = useState();
    const [showModal, setShowModal] = useState(false);
    const [fileForModal, setFileForModal] = useState("");

    const getFormattedDate = (d) => {
        var date = new Date(d);
        if (!d) return null;
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString().padStart(2, "0");
        let day = date.getDate().toString().padStart(2, "0");

        return month + "/" + day + "/" + year;
    };

    const getPrettyFileName = (fileName) => {
        let newFileName = fileName;
        let split = fileName.split(".");

        return split[0] + ".pdf";
    };

    const handleFileSelected = (index) => {
        //debugger;
        //START: Open file in new tab - THIS CODE WORKS
        //const payslip = payslips[index];
        //getData(payslip);
        //END: Open file in new tab

        //START: Open file modal
        let fileName =
            `Payslip/Employee/PayslipFile/` + payslips[index].identifier;
        setFileForModal(fileName);
        //setShowModal(true);
        //END: Open file modal
    };

    const handleUnselectFile = () => {
        //debugger;
        setFileForModal("");
    };

    useEffect(() => {
        setShowModal(true);
    }, [fileForModal]);

    async function getData(payslip) {
        if (!payslip.paySlipFileName) return;

        let fileName = `Payslip/Employee/PayslipFile/` + payslip.identifier;

        let result = await apiProvider.Get(
            fileName,
            null,
            "application/pdf",
            false
        );
        if (!result.error) {
            let fileData = result;
            var arrrayBuffer = base64ToArrayBuffer(result); //data is the base64 encoded string
            var blob = new Blob([arrrayBuffer], { type: "application/pdf" });
            var link = window.URL.createObjectURL(blob);
            setFileLink(link);
            window.open(link, "_blank");
        }
    }

    function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    return (
        <div className="payslip-list p-2 pt-0">
            <div className="row title-row" style={{marginLeft: '-7px', marginRight: '-7px', borderRadius: '8px 8px 0px 0px'}}>
                <div className="col col-5">Check Date</div>
                <div className="col col-5">Work Period</div>
                <div className="col col-2"></div>
            </div>
            {payslips.map((payslip, index) => (
                <div className="row" style={{marginLeft: '-7px', marginRight: '-7px'}}>
                    <div className="col col-5">
                        <button
                            className="btn btn-link cds-link p-0"
                            onClick={() => handleFileSelected(index)}
                        >
                            {getFormattedDate(payslip.issuedDate)}
                        </button>
                    </div>
                    {isPayslipAdmin ? (
                        <>
                            <div className="col col-5">
                                {getFormattedDate(payslip.dateFrom)}
                                {" - "}
                                {getFormattedDate(payslip.dateTo)}
                            </div>
                            <div className="col col-2">
                                <button
                                    className="btn btn-link cds-link p-0"
                                    onClick={() => onDeletePayslip(payslip.id)}
                                >
                                    <Icon.Trash className="icon" />
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="col col-5">
                                {getFormattedDate(payslip.dateFrom)}
                                {" - "}
                                {getFormattedDate(payslip.dateTo)}
                            </div>
                            <div className="col col-2"></div>
                        </>
                    )}
                </div>
            ))}

            {isMobile.any() ? (
                <MobilePDFViewer
                    fileName={fileForModal}
                    setFileName={handleUnselectFile}
                ></MobilePDFViewer>
            ) : (
                <PDFViewer
                    fileName={fileForModal}
                    setFileName={handleUnselectFile}
                ></PDFViewer>
            )}
            <div className="pt-2">Understanding your payslip: &nbsp;
                <a target="_blank" rel="noreferrer" href="https://claycorp.sharepoint.com/:v:/s/resources-axisreference/EQ2fVPKex15CvDG-vikca4MB_ktjdmve1eDGUWfAQ6uFTA?e=0gRYMw">English</a>
                &nbsp;&nbsp;
                <a target="_blank" rel="noreferrer" href="https://claycorp.sharepoint.com/:v:/s/resources-axisreference/ERWsjbQjR61LlQvrqzf9mkEBvF4N1-jWcLEWVxgvLwX1-g?e=EnJoEw">Español</a>
            </div>
        </div>
    );
};

export default PayslipList;
